import { Model } from '@vuex-orm/core'
import { v4 as uuid } from 'uuid'

import { replaceWhitespace, tokenize } from '@/utils/chat'
import { MAX_MESSAGES, PING_EVERYONE, PING_MODS } from '@/utils/constants/chat'
import { ROLE_MODERATOR } from '@/utils/constants/permissions'

class ChatMessage extends Model {
  static entity = 'chat-messages'

  static fields() {
    return {
      id: this.uid(() => uuid()),
      timestamp: this.attr(Date.now),
      user: this.attr(null).nullable(), // no relationship to users table for now
      text: this.string(''),
      room: this.string(''),
      deleted: this.boolean(false),
      content: this.attr([]),
      mentions: this.attr([]),
    }
  }

  get friendId() {
    if (!this.user) return null
    return `${this.user.name}#${this.user.shortId}`
  }

  static beforeCreate(model) {
    model.text = replaceWhitespace(model.text)
    model.content = tokenize(model.text)
  }

  static afterCreate(model) {
    // FIXME broadcasts (messages with no room) dont get cleared
    const messagesCount = ChatMessage.query().where('room', model.room).count()

    if (messagesCount > MAX_MESSAGES) {
      const oldestMessage = ChatMessage.query().where('room', model.room).first()
      oldestMessage.$delete()
    }
  }

  isPinged(user) {
    if (this.mentions.includes(PING_EVERYONE)) {
      return true
    }

    if (!user) return false

    if (this.mentions.includes(PING_MODS) && user.role === ROLE_MODERATOR) {
      return true
    }

    return this.mentions.includes(user.friendId)
  }
}

export default ChatMessage
